import { AddArticle } from '../../components/Articles';

const NewArticle = () => <AddArticle />;

export default NewArticle;
